import { createContext, useContext } from 'react';

// DUE VESTITI, UN COMPONENTE SOLO.
//
// `PropertiesPanel` non è del solo editor di scena: lo usano anche gli editor di preview3D, le
// impostazioni interfaccia e due pagine del Virtual Try-On. Il disegno nuovo — quello del
// prototipo — vale per la scena, e ridipingere qui dentro cambierebbe a vista sei pagine che
// nessuno sta riprovando.
//
// Quindi il disegno nuovo non è un componente nuovo: è un VESTITO che il pannello indossa quando
// glielo si chiede. Lo chiede una volta sola, `InspectorShell`, che è esattamente il confine
// della scena: tutto ciò che sta dentro un Inspector della scena si veste così, tutto il resto
// resta com'era. Quando il prototipo sarà chiuso e questo sarà il disegno di tutti, si toglie il
// contesto e resta un vestito solo — ed è per questo che i due stanno nello stesso file e non in
// due componenti gemelli: perché uno dei due deve poter sparire senza portarsi via l'altro.
//
// È lo stesso meccanismo che `$quiet` usa già sul contenitore, con un solo passaggio in più: qui
// il vestito lo deve vedere ogni riga, e passarlo di mano in mano per venti righe sarebbe la
// stessa parola scritta venti volte.
export type PropertiesPanelLook = 'default' | 'scene';

const PropertiesPanelLookContext = createContext<PropertiesPanelLook>('default');

export const PropertiesPanelLookProvider = PropertiesPanelLookContext.Provider;

export const usePropertiesPanelLook = (): PropertiesPanelLook => useContext(PropertiesPanelLookContext);

/** Scorciatoia per gli styled component, che di un vestito sanno solo se è quello o no. */
export const useIsSceneLook = (): boolean => usePropertiesPanelLook() === 'scene';
